import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-radio-default",
  "use": "ico-radio-default-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"ico-radio-default\">\n  <g id=\"ico-radio-default_Ellipse_136\" data-name=\"Ellipse 136\" fill=\"#fff\" stroke=\"#737878\" stroke-width=\"2\">\n    <circle cx=\"10\" cy=\"10\" r=\"10\" stroke=\"none\" />\n    <circle cx=\"10\" cy=\"10\" r=\"9\" fill=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol